import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/** Cuadrado partido en widgets (cuadrados/rectángulos) — dashboard personalizable. */
const DashboardWidgetsIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M4 4h7v7H4V4zm9 0h7v4h-7V4zM4 13h4v7H4v-7zm6 0h10v3H10v-3zm0 5h10v2H10v-2z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default DashboardWidgetsIcon;
